import { render, staticRenderFns } from "./CategorySubcategoryUpdate.vue?vue&type=template&id=140480a7&scoped=true"
import script from "./CategorySubcategoryUpdate.vue?vue&type=script&lang=js"
export * from "./CategorySubcategoryUpdate.vue?vue&type=script&lang=js"
import style0 from "./CategorySubcategoryUpdate.vue?vue&type=style&index=0&id=140480a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140480a7",
  null
  
)

export default component.exports